import BaseProductEditorMixin from "@/modules/core/product/protected/BaseProductEditorMixin";
import service from "./MicroCreditProductService";
import ProductForm from "./MicroCreditProductForm";

export default {
  mixins: [BaseProductEditorMixin],

  created() {
    this.ProductForm = ProductForm;
  },

  methods: {
    getService() {
      return service;
    }
  }
};
